// extracted by mini-css-extract-plugin
export var container = "_co-0";